import React from 'react';
const ZIndexContext = React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
    ZIndexContext.displayName = 'ZIndexContext';
}
export default ZIndexContext;
